import styled from 'styled-components';

const styledPolicyPolicy = styled.div`
h1{
 font-size: 24px;
 font-weight: bold
}
h2{
 font-size: 14px;
 font-weight: bold;
 color: #444
}
p{
 font-size:13px;
 color: #444;
 line-height: 1.6
}
li{
 font-size: 13px;
 color: #444;
 line-height: 1.6
}
a{
 text-decoration: none;
 color: #76b5f1
}
`;

export default styledPolicyPolicy;



// WEBPACK FOOTER //
// client/containers/PrivacyPolicy/StyledPrivacyPolicy.js